<template>
  <div>
    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      SOCIOS
    </p>

    <!-- <p class="mb-10" style="font-size: 20pt; text-align: center">
      Este es tú espacio de configuracion, aquí puedes registrar, editar y
      administrar: <br />
      Variables, Indices, Clima a Largo Plazo y crear Publicaciones.
    </p> -->

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >{{ patrocinadores.length }} Socio (s)</v-toolbar-title
        >

        <v-spacer></v-spacer>

        <v-btn depressed color="primary" @click="addPatrocinadorDialog = true">
          <v-icon left dark> mdi-plus </v-icon>
          Agregar Socio
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list v-if="patrocinadores.length > 0" two-line subheader>
              <v-list-item v-for="item in patrocinadores" :key="item.Name">
                <v-list-item-avatar>
                  <v-img :src="item.Data.url"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.Name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <p class="mb-0" style="line-height: 20px">
                      {{ item.Data.description }}
                    </p>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <!-- <v-list-item @click="openDialogEditPublication(item)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="blue-grey">mdi-pencil-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>-->
                      <v-list-item @click="deleteSponsor(item.Id)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="red">mdi-delete-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Eliminar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="my-2 d-flex justify-center">
              <p style="font-size: 12pt" class="mb-0">
                No hay socios registrados, !Registra uno!
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addPatrocinadorDialog" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Nuevo Socio</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelDialogAddPatrocinador()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-3">
          <v-container>
            <v-form ref="formAddPatrocinador">
              <v-row>
                <v-img
                  contain
                  v-if="newPatrocinador.data.url"
                  :src="newPatrocinador.data.url"
                  height="180"
                ></v-img>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="newPatrocinador.data.url"
                    label="URL Imagen Socio"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newPatrocinador.data.weburl"
                    label="URL del sitio web http://www.example.com"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newPatrocinador.Name"
                    label="Nombre Socio"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newPatrocinador.data.description"
                    label="Descripción Socio"
                    outlined
                    rows="4"
                    counter="300"
                    :rules="rules"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddPatrocinador()"
            >Cancelar</v-btn
          >
          <v-btn text @click="addPatrocinador(newPatrocinador)" large>Guardar</v-btn>
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddPatrocinador">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
      >{{ snackbar.text }}</v-snackbar
    >

    <v-overlay :value="loadingScreen">
      <v-progress-circular
        class="mb-4"
        indeterminate
        size="64"
      ></v-progress-circular>
      <p>Cargando...</p>
    </v-overlay>
  </div>
</template>

<script>
import api from "@/api/api";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import { Heading, Bold } from "tiptap-extensions";

export default {
  name: "Home",
  components: {
    EditorContent,
    EditorMenuBar,
  },
  data() {
    return {
      addPatrocinadorDialog: false,
      loadingAddPatrocinador: false,
      newPatrocinador: {
        Name: "",
        data:{
          description: "",
          url: "",
          weburl:"",
        },
      },
      patrocinadores: [],

      publicaciones: [],
      formPublication: {
        indices: [],
        variables: [],
      },
      newPublication: {
        Name: {
          es: null,
        },
        Introduction: {
          es: null,
        },
        Body: {
          es: {
            First: null,
            Second: null,
          },
        },
        Indices: [],
        Variables: [],
        Data: {
          LinkImage: null,
        },
      },
      addPublicationDialog: false,
      addIndicePublication: false,
      newIndicePublicacion: {
        Indice: null,
        Body: {
          es: null,
        },
        Destacar: false,
      },
      addVariablePublication: false,
      newVariablePublicacion: {
        Variable: null,
        Body: {
          es: null,
        },
      },
      rules: [(v) => !!v || "Este campo es requerido"],
      rulesMultiple: [
        (v) => {
          if (!v || v.length < 1) {
            return "Este campo es requerido";
          } else {
            return true;
          }
        },
      ],
      loadingAddPublication: false,
      updatePublicationDialog: false,
      updatePublication: null,
      editorAdd: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newPublication.Body.es.First = getHTML();
        },
      }),
      editorAdd2: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newPublication.Body.es.Second = getHTML();
        },
      }),
      editorAddIndice: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newIndicePublicacion.Body.es = getHTML();
        },
      }),
      editorAddVariable: new Editor({
        extensions: [new Heading({ levels: [1, 2, 3] }), new Bold()],
        content: "",
        onUpdate: ({ getHTML }) => {
          this.newVariablePublicacion.Body.es = getHTML();
        },
      }),
      snackbar: {
        show: false,
        text: null,
        color: null,
      },
      loadingScreen: false,
    };
  },
  mounted() {
    this.getPatrocinadores();
  },
  methods: {
    async getPatrocinadores() {
      try {
        this.loadingScreen = true;
        const data = await api.getPatrocinadores();
        if (data.data.status) {
          this.patrocinadores = data.data.data;
          console.log(data.data.data);
        }
        this.loadingScreen = false;
      } catch (err) {
        console.log(err);
      }
    },
    async deleteSponsor(idSponsor) {
      try {
        this.loadingScreen = true;
        let data = await api.deleteSponsor(idSponsor);
        this.loadingScreen = false;
        this.showSnackbar("El patrocinador se eliminó correctamente", "success");
        this.getPatrocinadores();
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddPatrocinador() {
      this.addPatrocinadorDialog = false;
    },
    async addPatrocinador(newPatrocinador) {
      if (this.$refs.formAddPatrocinador.validate()) {
        // this.loadingAddPatrocinador = true;
        const data = await api.addPatrocinador(newPatrocinador);
        console.log(data);
        this.loadingAddPatrocinador = false;
        // if (data.status) {
        // this.patrocinadores.push(data.data);
        this.addPatrocinadorDialog = false;
        this.$refs.formAddPatrocinador.reset();
        this.getPatrocinadores();
        // }
      }
    },
    cancelDialogAddIndicePublicacion() {
      this.addIndicePublication = false;
    },
    addVariablePublicacion(data) {
      try {
        this.newPublication.Variables.push(data);
        this.newVariablePublicacion = {
          Variable: null,
          Body: {
            es: null,
          },
        };
        this.editorAddVariable.clearContent();
        this.addVariablePublication = false;
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddVariablePublicacion() {
      this.addVariablePublication = false;
    },
    async addPublication(newPublication) {
      try {
        if (this.$refs.formAddPublication.validate()) {
          if (
            newPublication.Indices.length > 0 ||
            newPublication.Indices.length > 0
          ) {
            this.loadingAddPublication = true;
            const data = await api.addPublication(newPublication);
            this.loadingAddPublication = false;
            if (data.status) {
              this.addPublicationDialog = false;
              this.newPublication = {
                Name: {
                  es: null,
                },
                Introduction: {
                  es: null,
                },
                Body: {
                  es: {
                    First: null,
                    Second: null,
                  },
                },
                Indices: [],
                Variables: [],
                Data: {
                  LinkImage: null,
                },
              };
              this.editorAdd.clearContent();
              this.$refs.formAddPublication.reset();
              this.getPublicaciones();
            }
          } else {
            this.showSnackbar(
              "¡Debes agregar al menos un Indice o Variable!",
              "error"
            );
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddPublicacion() {
      this.$refs.formAddPublication.reset();
      this.addPublicationDialog = false;
    },
    openDialogEditPublication(item) {
      this.updatePublication = item;
      this.getIndices();
      this.getVariables();
      this.updatePublicationDialog = true;
    },
    cancelDialogEditPublication() {
      this.updatePublicationDialog = false;
    },
    async deletePublication(idPublication) {
      try {
        this.loadingScreen = true;
        let data = await api.deletePublication(idPublication);
        this.loadingScreen = false;
        this.showSnackbar("La publicación se eliminó correctamente", "success");
        this.getPublicaciones();
      } catch (err) {
        console.err(err);
      }
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    irAtras() {
      this.$router.go(-1);
    },
  },
  beforeDestroy() {
    // Always destroy your editor instance when it's no longer needed
    if (this.editor) {
      this.editor.destroy();
    }
  },
};
</script>